// Taken from https://stackoverflow.com/questions/29698796/how-to-convert-html-table-to-excel-with-multiple-sheet
// Could use some work, but it works.

export default {
  // The install method will be called with the Vue constructor as         
  // the first argument, along with possible options
  install (Vue, options) {
    const table2excel = {
      
      // 
      // downloadTable 
      // use:
      //  this.$table2excel.downloadTable(['tableid', 'etc.'], ['sheetName', 'etc'], 'bookName')
      // yyyy-mm-dd hh:mm:ss
      downloadTable: (function() {
        return function(tablesNames, wsnames, wbname, options={}, appname="Excel") {
          //I'm not particularly sure why this returns a function within a function, TODO fix
          options.DateFormat = !options.DateFormat ? 'mm/dd/yy;@' : options.DateFormat;
          const uri = 'data:application/vnd.ms-excel;base64,'
          const tmplWorkbookXML = `<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
            <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>Daily Sys</Author><Created>{created}</Created></DocumentProperties>
            <Styles>
            <Style ss:ID="Currency"><NumberFormat ss:Format="Currency"></NumberFormat></Style>
            <Style ss:ID="Decimal"><NumberFormat ss:Format="_-* #,##0.00_-;-* #,##0.00_-;_-* &quot;-&quot;??_-;_-@_-"></NumberFormat></Style>
            <Style ss:ID="Number"><NumberFormat ss:Format="_-* #,##0_-;-* #,##0_-;_-* &quot;-&quot;??_-;_-@_-"></NumberFormat></Style>
            <Style ss:ID="Date"><NumberFormat ss:Format="${options.DateFormat}"></NumberFormat></Style>
            
            </Styles>
            <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel">
              <WindowHeight>15000</WindowHeight>
              <WindowWidth>20500</WindowWidth>
              <WindowTopX>0</WindowTopX>
              <WindowTopY>0</WindowTopY>
              <ProtectStructure>False</ProtectStructure>
              <ProtectWindows>False</ProtectWindows>
            </ExcelWorkbook>
            {worksheets}</Workbook>`
          const tmplWorksheetXML = '<Worksheet ss:Name="{nameWS}"><Table>{rows}</Table></Worksheet>'
          const tmplCellXML = '<Cell{attributeStyleID}{attributeFormula}><Data ss:Type="{nameType}">{data}</Data></Cell>'
          const base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
          const format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }

          let worksheetsXML = "";
          
    
          for (var i = 0; i < tablesNames.length; i++) {
            const table = document.getElementById(tablesNames[i])
            if (table === null) { continue; }
            let rowsXML = ''
            for (var j = 0; j < table.rows.length; j++) {
              rowsXML += '<Row>'
              for (var k = 0; k < table.rows[j].cells.length; k++) {
                var dataType = table.rows[j].cells[k].getAttribute("data-type");
                var dataStyle = table.rows[j].cells[k].getAttribute("data-style");
                var dataValue = table.rows[j].cells[k].getAttribute("data-value");
                //Changed from innerHTML to innerText, not sure if this will break anything
                dataValue = (dataValue)?dataValue:table.rows[j].cells[k].innerText;
                dataValue = dataValue.trim()
                var dataFormula = table.rows[j].cells[k].getAttribute("data-formula");
                dataFormula = (dataFormula)?dataFormula:(appname=='Calc' && dataType=='DateTime')?dataValue:null;
                const ctx = {  attributeStyleID: (dataStyle=='Currency' || dataStyle=='Number' || dataStyle=='Decimal' || dataStyle=='Date')?' ss:StyleID="'+dataStyle+'"':''
                        , nameType: (dataType=='Number' || dataType=='DateTime' || dataType=='Boolean' || dataType=='Error')?dataType:'String'
                        , data: (dataFormula)?'':dataValue
                        , attributeFormula: (dataFormula)?' ss:Formula="'+dataFormula+'"':''
                      };
                rowsXML += format(tmplCellXML, ctx);
              }
              rowsXML += '</Row>\n'
            }
            const ctx = {rows: rowsXML, nameWS: wsnames[i] || 'Sheet' + i};
            worksheetsXML += format(tmplWorksheetXML, ctx);
          }
    
          const ctx = {created: (new Date()).getTime(), worksheets: worksheetsXML};
          const workbookXML = format(tmplWorkbookXML, ctx);
    
    
    
          var link = document.createElement("A");
          link.href = uri + base64(workbookXML);
          link.download = wbname || 'Workbook.xls';
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })(),

      excelDataType(data){
        if (data instanceof Date){
          return "DateTime"
        }
        if (typeof data === "string" && data.length === 24 && isValidDate(new Date(data))){
          data = moment.utc(data).format("YYYY-MM-DD h:mm:ss a");
          return "DateTime";
        }
        if (typeof data === "number"){
          return "Number"
        }
        if (data === " - " || data === "-"){
          return "Number"
        }
        else {
          return "String"
        }
      },

      excelDataStyle(data /*, style*/){
        const dataType = table2excel.excelDataType(data)
        // if (style !== undefined){
        //   return style;
        // }
        if( dataType === "Number"){
          return "Comma"
        }
        if( dataType === "DateTime"){
          return "Date"
        } else {
          return "";
        }
      },
      excelDataValue(data){
        let result = data
        if(data instanceof Date){
          // 210629 hack, excel doesn't like the default date formatting
          result = moment(data).format('YYYY-MM-DD[T]HH:mm:ss.000[Z]')
        }
        if(Number.isNaN(data)){
          result = 0;
        }
        return result === " - " || result === "-" ? 0 : result;
      },
      excelRemoveBR(data){
        return data.replace(/\<br\>/g, ' ')
      }
    }

    function isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    }
    

    Vue.prototype.$table2excel = table2excel
    

  }
}